module.exports = __webpack_public_path__ + "img/latex.8d9ebece.png";